import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController, LoadingController, ViewController } from 'ionic-angular';
import { ModalController } from 'ionic-angular';

import { ImcpaAppProvider } from '../../../providers/imcpaApp/imcpaApp';
import { CertificateModalPage } from '../certificateModal/certificateModal';

@Component({
  selector: 'page-certificate',
  templateUrl: 'certificate.html',
  // styleUrls: [ 'certificate.scss', '../../theme/variables.scss' ]

})
export class CertificatePage {
  public resources = [];
  public key: any;
 
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    // private iab: InAppBrowser,
    public myApp: ImcpaAppProvider,
    public modalCtrl: ModalController,

  ) {
      this.initializeItems();
        // this.goshalas = this.myApp.getGoshalas();
      // this.getGoshalas();
      // console.log(this.goshalas);
  }

  initializeItems() {
    this.resources = this.myApp.getResources();
  }

  getItems(ev: any) {
    // Reset items back to all of the items
    this.initializeItems();

    // set val to the value of the searchbar
    const val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.resources = this.resources.filter((goshala) => {
        return (goshala.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }
    presentModal(display) {
    const modal = this.modalCtrl.create(CertificateModalPage, {display: display});
    modal.present();
  }

  // OpenUrl(resource)
  // {
  //   window.open("http://google.com",'_system', 'location=yes');
  // const browser = this.iab.create('resource.bookLink');
  // browser.show()
  // }

  //   goToViewResourcePage(resource){
  //   this.navCtrl.push(ViewResourcePage, {resource: resource});
  // }

}



// WEBPACK FOOTER //
// ./src/pages/certificate/certificate/certificate.ts